import { Suspense } from 'react'
import { useTranslation } from 'react-i18next'
import { Outlet } from 'react-router-dom'

import { useSeoMeta } from '@unhead/react'
import { NS } from 'src/constants/i18n'
import { PageLayout } from 'src/layouts/PageLayout'

export const App = () => {
  const { t } = useTranslation(NS.COMMON)
  useSeoMeta({ title: t('meta.title'), robots: 'noindex, nofollow' })

  return (
    <Suspense fallback={null}>
      <PageLayout>
        <Outlet />
      </PageLayout>
    </Suspense>
  )
}

export default App
